import { v4 as uuidv4 } from 'uuid';
import { Button, Form, Header, SpaceBetween, Grid } from '@amzn/awsui-components-react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { useEffect, useState, useMemo } from 'react';
import { bindActionCreators } from 'redux';
import { get, isEmpty, isNull, isPlainObject } from 'lodash';
import { push } from 'connected-react-router';
import { getAllImportMetadataAction } from '../../../import_data/redux/GetAllImportMetadata';
import { SUPPORTED_IMPORT_TYPES, IMPORT_STATUS } from '../../../import_data/constants/import_types';
import { uploadFileToS3Action } from '../../../../common/components/file_importer/redux/actions/UploadFileToS3';
import { getUploadToS3PayloadForTriggerImport } from '../../../import_data/utils/import_utils';
import Page from '../../../../common/components/with_page/Page';
import { RESOURCE } from '../../../auth/constants/rbac_constants';
import { BRC_ITEMS_PAGE } from '../../../../common/components/with_page/components/bread_crumb/constants';
import { getStudyPeriod } from '../../../../common/constants/study_period';
import { exportDataAction } from '../../../../common/redux/export';
import { DEFAULT_BUSINESS_ID, DEFAULT_COUNTRY } from '../../../../common/config/api_constants';
import DetailComponent from './components/detail-section';
import AttachmentComponent from './components/attachment-section';
import TemplatePreviewComponent from './components/template-preview-section';
import DeliveryScheduleComponent from './components/delivery-schedule-section';
import SurveyFilterSection from './components/survey-filter-section';
import {
  isAnyDaysOfWeekChecked,
  isEventSchedule,
  isOneTimeSchedule,
  isOnReferenceDateNotSelected,
  isRecurringSchedule,
  ONE_TIME_INITIAL_STATE,
  RECURRING_INITIAL_STATE,
  TRIGGERING_EVENT_INITIAL_STATE,
} from './constants/delivery-schedule-constant';
import { configureNotificationAction } from './redux/configure-notification-slice';
import createNotificationPayload from '../utils/api-utils';
import { getNotificationFormDataAction } from './redux/notification-form-data';
import { getRoutePathWithStudyPeriod, ROUTE_PATH } from '../../../../common/constants/route_paths';
import { configureAttachmentStateAction } from './redux/configureAttachmentState';
import {
  getSelectedCCListOption,
  getSelectedDaysOfWeek,
  getSelectedIdentifiersList,
  getSelectedObject,
  getUploadedAttachment,
} from '../utils/edit-notification-utils';

const ConfigureRiseNotificationPage = ({
  studyPeriod,
  entityId,
  studyType,
  pageHeaderName,
  configureNotificationBegin,
  attachments,
  getNotificationFormData,
  navigateTo,
  history,
  notificationFormData,
  clearNotificationAttachments,
  addAttachments,
  uploadFileToS3,
  exportDataBegin,
  getAllImportMetadata,
  importMetadataData,
}) => {
  const notificationDetailsData = get(history, 'location.state', null) || null;
  const fileImportType = SUPPORTED_IMPORT_TYPES.NOTIFICATION_SURVEY_FILTER[0];

  const surveyTypeMap = {
    LABOR_BC_SUBSTANTIATION: 'LaborBCSubstantiation',
    LABOR_PROJECT_SUBSTANTIATION: 'LaborProjectSubstantiation',
  };

  const [formDataCache, setFormDataCache] = useState({
    LaborBCSubstantiation: null,
    LaborProjectSubstantiation: null,
  });

  useEffect(() => {
    if (notificationFormData && notificationFormData.surveyType) {
      setFormDataCache(prev => ({
        ...prev,
        [notificationFormData.surveyType]: notificationFormData,
      }));
    }
  }, [notificationFormData]);

  useEffect(() => {
    getNotificationFormData({
      body: {
        surveyType: 'LaborBCSubstantiation',
      },
    });

    getNotificationFormData({
      body: {
        surveyType: 'LaborProjectSubstantiation',
      },
    });
    // eslint-disable-next-line
  }, []);
  const [detailComponentState, setDetailComponentState] = React.useState({
    name: '',
    template: { label: null, value: null },
    recipient: { label: null, value: null },
    selectedCCList: [],
    applicableTo: { label: null, value: null },
    applicableCCOperation: { label: null, value: null },
    selectedCostCenterIdentifier: [],
    applicableFGBSVPOperation: { label: null, value: null },
    selectedFGBSVPIdentifier: [],
    selectedApplicableEntitySection: { label: null, value: null },
  });

  const [deliverySchedule, setDeliverySchedule] = React.useState({
    frequency: { label: null, value: null },
    trigger: { label: null, value: null },
    ...TRIGGERING_EVENT_INITIAL_STATE,
    ...ONE_TIME_INITIAL_STATE,
    ...RECURRING_INITIAL_STATE,
  });

  const [surveyFilterFile, setSurveyFilterFile] = React.useState(null);
  const [filterUploadUUID, setFilterUploadUUID] = React.useState(null);
  const [importStatus, setImportStatus] = React.useState(null);
  const [failedTemplateURL, setFailedTemplateURL] = React.useState(null);

  const [editNotificationId, setEditNotificationId] = React.useState(null);

  useEffect(() => {
    if (
      !isNull(notificationFormData) &&
      !isNull(notificationDetailsData) &&
      isPlainObject(notificationDetailsData)
    ) {
      setEditNotificationId(notificationDetailsData.notificationId);
      setDetailComponentState({
        name: notificationDetailsData.notificationName,
        template: getSelectedObject(
          notificationFormData.template,
          notificationDetailsData.templateId,
        ),
        recipient: getSelectedObject(
          notificationFormData.recipient,
          notificationDetailsData.recipient,
        ),
        selectedCCList: getSelectedCCListOption(
          notificationFormData.ccList,
          notificationDetailsData.ccList,
        ),
        applicableTo: getSelectedObject(
          notificationFormData.applicable,
          notificationDetailsData.applicableTo,
        ),
        applicableCCOperation: getSelectedObject(
          notificationFormData.applicableCostCenterOperation,
          notificationDetailsData.applicableCostCenter.operation,
        ),
        selectedCostCenterIdentifier: getSelectedIdentifiersList(
          notificationDetailsData.applicableCostCenter.costCenterIdentifiers,
        ),
        applicableFGBSVPOperation: getSelectedObject(
          notificationFormData.applicableFGBSVPOperation,
          get(notificationDetailsData, 'applicableFGBSVP.fgbsvpOperation', null),
        ),
        selectedFGBSVPIdentifier: getSelectedIdentifiersList(
          get(notificationDetailsData, 'applicableFGBSVP.fgbsvpIdentifiers', []),
        ),
        selectedApplicableEntitySection: getSelectedObject(
          notificationFormData.applicableEntitySection,
          get(notificationDetailsData, 'applicableEntitySection.0', null),
        ),
      });
      const deliveryScheduleData = JSON.parse(notificationDetailsData.deliverySchedule);
      setDeliverySchedule({
        frequency: getSelectedObject(
          notificationFormData.frequency,
          deliveryScheduleData.frequency,
        ),
        trigger: getSelectedObject(notificationFormData.trigger, deliveryScheduleData.trigger),
        triggeringEvent: getSelectedObject(
          notificationFormData.triggeringEvent,
          deliveryScheduleData.schedule.event,
        ),
        relativeOperator: getSelectedObject(
          notificationFormData.relativeOperator,
          deliveryScheduleData.schedule.relativeOperator,
        ),
        deliveryTime: getSelectedObject(
          notificationFormData.deliveryTime,
          deliveryScheduleData.schedule.deliveryTime,
        ),
        relativeDate: getSelectedObject(
          notificationFormData.relativeDate,
          deliveryScheduleData.schedule.relativeDate,
        ),
        temporalUnit: getSelectedObject(
          notificationFormData.temporalUnit,
          deliveryScheduleData.schedule.temporalUnit,
        ),
        temporalData: deliveryScheduleData.schedule.temporalData,
        relativeStartDate: getSelectedObject(
          notificationFormData.relativeDate,
          deliveryScheduleData.schedule.relativeStartDate,
        ),
        relativeStartDateValue: deliveryScheduleData.schedule.relativeStartDateValue,
        relativeEndDate: getSelectedObject(
          notificationFormData.relativeDate,
          deliveryScheduleData.schedule.relativeEndDate,
        ),
        relativeEndDateValue: deliveryScheduleData.schedule.relativeEndDateValue,
        temporalDataList: deliveryScheduleData.schedule.temporalDataList,
        daysOfWeek: getSelectedDaysOfWeek(
          deliveryScheduleData.schedule.temporalDataList,
          deliverySchedule,
        ),
      });
      getUploadedAttachment(
        notificationDetailsData.attachments,
        clearNotificationAttachments,
        addAttachments,
      );
    }
    if (!isNull(notificationFormData) && isNull(notificationDetailsData)) {
      setDetailComponentState(prevDetails => ({
        ...prevDetails,
        selectedApplicableEntitySection: getSelectedObject(
          notificationFormData.applicableEntitySection,
          get(notificationFormData, 'applicableEntitySection.0.value', null),
        ),
      }));
    }
    // eslint-disable-next-line
  }, [notificationFormData, notificationDetailsData]);

  useEffect(() => {
    if (importMetadataData && filterUploadUUID) {
      const importRecords = importMetadataData.body?.importRecords || [];
      const matchingRecord = importRecords.find(
        record => record.importMetadata?.filterId === filterUploadUUID,
      );

      if (matchingRecord) {
        setImportStatus(matchingRecord.importStatus);
        setFailedTemplateURL(matchingRecord.failedTemplateURL);
      }
    }
  }, [importMetadataData, filterUploadUUID]);

  const onFileUpload = file => {
    setSurveyFilterFile(file);

    const uploadUUID = uuidv4();
    setFilterUploadUUID(uploadUUID);

    uploadFileToS3(
      getUploadToS3PayloadForTriggerImport({
        documentFile: file,
        fileImportType,
        importMetadata: { filterId: uploadUUID, filterType: 'INCLUSIVE' },
      }),
    );
  };

  const onFileDelete = () => {
    setFilterUploadUUID(null);
    setImportStatus(null);
    setFailedTemplateURL(null);
  };

  const onUpdateStatus = async uploadUUID => {
    if (!uploadUUID) return;

    getAllImportMetadata({
      body: {
        importTypes: ['NotificationSurveyFilter'],
        includeAllUsers: true,
      },
    });
  };

  const onCreateHandler = () => {
    const surveyFilterData = surveyFilterFile
      ? {
          filterId: filterUploadUUID,
          surveyFilterType: 'INCLUSIVE',
        }
      : null;

    const notificationPayload = createNotificationPayload(
      editNotificationId,
      detailComponentState,
      attachments,
      deliverySchedule,
      surveyFilterData,
    );

    configureNotificationBegin({
      body: {
        notification: notificationPayload,
      },
      onSuccess: notificationId => {
        navigateTo({
          pathname: getRoutePathWithStudyPeriod(
            ROUTE_PATH.RISE_NOTIFICATION_DETAIL_PAGE,
            studyPeriod,
          ),
          state: notificationId,
        });
        clearNotificationAttachments();
      },
    });
  };

  const onCancelHandler = () => {
    navigateTo({
      pathname: getRoutePathWithStudyPeriod(ROUTE_PATH.RISE_NOTIFICATION_PAGE, studyPeriod),
    });
  };

  const onDownloadHandler = ({ detail }) => {
    if (detail.id === 'filter-template') {
      fetch(`${process.env.PUBLIC_URL}/static-content/rise/SurveyFilterTemplate.xlsx`)
        .then(response => {
          if (!response.ok) throw new Error('Download failed');
          return response.blob();
        })
        .then(blob => {
          const url = window.URL.createObjectURL(
            new Blob([blob], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            }),
          );
          const link = document.createElement('a');
          link.href = url;
          link.download = 'SurveyFilterTemplate.xlsx';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch(error => console.error('Download failed:', error));
    } else if (detail.id === 'all-surveys') {
      const applicableValue = detailComponentState.applicableTo.value;
      const surveyType = surveyTypeMap[applicableValue] || applicableValue;
      exportDataBegin({
        body: {
          type: 'SURVEYS_EXTRACT',
          isJSON: false,
          query: {
            studyPeriod,
            country: DEFAULT_COUNTRY,
            clientId: DEFAULT_BUSINESS_ID + (entityId === undefined ? '' : entityId),
            surveyType,
            query: '',
          },
        },
      });
    }
  };

  const getDownloadLabel = () => {
    const surveyType = detailComponentState.applicableTo.value;
    if (surveyType === 'LABOR_BC_SUBSTANTIATION') {
      return 'All substantiation primary owner surveys info';
    }
    if (surveyType === 'LABOR_PROJECT_SUBSTANTIATION') {
      return 'All substantiation provider surveys info';
    }
    return '';
  };

  const isCreateButtonDisabled = useMemo(() => {
    if (
      isEmpty(detailComponentState.name) ||
      isNull(detailComponentState.template.value) ||
      isNull(detailComponentState.recipient.value) ||
      isNull(detailComponentState.applicableTo.value) ||
      isNull(deliverySchedule.frequency.value)
    ) {
      return true;
    }

    if (
      surveyFilterFile &&
      (importStatus === IMPORT_STATUS.Triggered ||
        importStatus === IMPORT_STATUS.InProgress ||
        importStatus === IMPORT_STATUS.ValidationFailure ||
        importStatus === null)
    ) {
      return true;
    }

    if (isEventSchedule(deliverySchedule)) {
      return isNull(deliverySchedule.triggeringEvent.value);
    }
    if (isOnReferenceDateNotSelected(deliverySchedule)) {
      return isEmpty(deliverySchedule.temporalData) || isNull(deliverySchedule.temporalUnit.value);
    }
    if (isOneTimeSchedule(deliverySchedule)) {
      return (
        isEmpty(deliverySchedule.relativeDate.value) ||
        isNull(deliverySchedule.relativeOperator.value)
      );
    }
    if (!isRecurringSchedule(deliverySchedule)) {
      return isNull(deliverySchedule.trigger.value);
    }
    if (isRecurringSchedule(deliverySchedule)) {
      return (
        isNull(deliverySchedule.relativeStartDate.value) ||
        isNull(deliverySchedule.relativeEndDate.value) ||
        !isAnyDaysOfWeekChecked(deliverySchedule)
      );
    }
    return false;
  }, [detailComponentState, deliverySchedule, surveyFilterFile, importStatus]);

  const content = (
    <SpaceBetween size="l">
      <Header variant="h1">{pageHeaderName}</Header>
      <Grid gridDefinition={[{ colspan: 5 }, { colspan: 5 }, { colspan: 2 }]}>
        <TemplatePreviewComponent selectedTemplate={detailComponentState.template} />
        <Form
          actions={
            <SpaceBetween direction="horizontal" size="xs">
              <Button variant="normal" onClick={onCancelHandler}>
                Cancel
              </Button>
              <Button variant="primary" onClick={onCreateHandler} disabled={isCreateButtonDisabled}>
                {isNull(notificationDetailsData) ? 'Create' : 'Save'}
              </Button>
            </SpaceBetween>
          }
        >
          <SpaceBetween size="xl">
            <DetailComponent
              detailComponentState={detailComponentState}
              setDetailComponentState={setDetailComponentState}
              formDataCache={formDataCache}
            />
            <AttachmentComponent />
            <DeliveryScheduleComponent
              deliverySchedule={deliverySchedule}
              setDeliverySchedule={setDeliverySchedule}
              formDataCache={formDataCache}
            />
            <SurveyFilterSection
              surveyFilterFile={surveyFilterFile}
              setSurveyFilterFile={setSurveyFilterFile}
              onDownloadHandler={onDownloadHandler}
              getDownloadLabel={getDownloadLabel}
              applicableToValue={detailComponentState.applicableTo.value}
              onFileUpload={onFileUpload}
              onFileDelete={onFileDelete}
              filterUploadUUID={filterUploadUUID}
              onUpdateStatus={onUpdateStatus}
              importStatus={importStatus}
              failedTemplateURL={failedTemplateURL}
            />
          </SpaceBetween>
        </Form>
      </Grid>
    </SpaceBetween>
  );

  return (
    <Page
      PageId={RESOURCE.PAGE_RISE_NOTIFICATIONS}
      isPageAccessControlled={false}
      PageContent={content}
      breadCrumbItems={BRC_ITEMS_PAGE.CREATE_RISE_NOTIFICATION(
        studyPeriod,
        entityId,
        studyType,
        pageHeaderName,
      )}
    />
  );
};

ConfigureRiseNotificationPage.propTypes = {
  studyPeriod: PropTypes.string.isRequired,
  entityId: PropTypes.string,
  studyType: PropTypes.string.isRequired,
  pageHeaderName: PropTypes.string,
  configureNotificationBegin: PropTypes.func.isRequired,
  attachments: PropTypes.array.isRequired,
  getNotificationFormData: PropTypes.func.isRequired,
  navigateTo: PropTypes.func.isRequired,
  notificationFormData: PropTypes.object,
  history: PropTypes.object.isRequired,
  clearNotificationAttachments: PropTypes.func.isRequired,
  addAttachments: PropTypes.func.isRequired,
  uploadFileToS3: PropTypes.func.isRequired,
  exportDataBegin: PropTypes.func.isRequired,
  getAllImportMetadata: PropTypes.func.isRequired,
  importMetadataData: PropTypes.object,
};

const mapStateToProps = state => {
  const notificationDetailData = get(state, 'router.location.state', null);
  return {
    studyPeriod: getStudyPeriod(state),
    entityId: get(state, 'entityId.entityId', undefined),
    studyType: get(state, 'studyType.studyType'),
    attachments: get(state, 'entities.notifications.configureAttachmentState.attachments', []),
    notificationFormData: get(state, 'entities.notifications.notificationFormData.data', null),
    pageHeaderName: isNull(notificationDetailData) ? 'New notification' : 'Edit notification',
    importMetadataData: get(state, 'entities.getAllImportMetadata.data', null),
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      configureNotificationBegin: configureNotificationAction.BEGIN,
      getNotificationFormData: getNotificationFormDataAction.BEGIN,
      navigateTo: payload => push(payload),
      clearNotificationAttachments: configureAttachmentStateAction.CLEAR,
      addAttachments: configureAttachmentStateAction.ADD,
      uploadFileToS3: uploadFileToS3Action,
      exportDataBegin: exportDataAction.BEGIN,
      getAllImportMetadata: getAllImportMetadataAction.BEGIN,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(ConfigureRiseNotificationPage);
